import { defineMessages } from 'react-intl';

/**
 * Design o: every surface a team member sees instead of a checkout button. The headline itself
 * reuses `upgradeMessages.memberCta` ("Ask the workspace owner to upgrade.") so the sentence
 * never drifts between surfaces — these are the lines that name the owner underneath it.
 */
export const teamOwnerMessages = defineMessages({
  managesBilling: {
    id: 'app.sml.team.owner.managesBilling',
    defaultMessage: '{email} manages billing for this workspace.',
  },
  managesPlan: {
    id: 'app.sml.team.owner.managesPlan',
    defaultMessage: '{email} manages the plan.',
  },
  choosesPlan: {
    id: 'app.sml.team.owner.choosesPlan',
    defaultMessage: '{email} chooses the plan for this workspace.',
  },
  worksIn: {
    id: 'app.sml.team.owner.worksIn',
    defaultMessage: 'You work in {workspace} as a team member.',
  },
  caption: {
    id: 'app.sml.team.owner.caption',
    defaultMessage: 'owner, manages billing',
  },
  ownerOnly: {
    id: 'app.sml.team.owner.ownerOnly',
    defaultMessage: 'Owner only',
  },
});
